const sidebar1 = (editor) => {

    editor.BlockManager.add(`sidebar1`, {
        category: 'Sidebars',
        label: ` 
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                width="1.4rem" height="1.4rem" viewBox="0 0 128.000000 128.000000"
                preserveAspectRatio="xMidYMid meet">
            
            <g transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
            fill="#000000" stroke="none">
            <path class="gjs-block-svg-path" 
            d="M223 1139 c-43 -13 -80 -60 -88 -112 -3 -23 -5 -213 -3 -422 3 -418
            2 -411 65 -452 25 -16 63 -18 443 -18 380 0 418 2 443 18 63 41 62 30 62 487
            0 380 -2 418 -18 443 -41 63 -32 62 -472 64 -226 1 -414 -2 -432 -8z m227
            -499 l0 -450 -107 0 c-96 0 -109 2 -130 22 l-23 21 0 406 c0 492 -14 451 152
            451 l108 0 0 -450z m617 428 l23 -21 0 -406 c0 -402 0 -405 -22 -428 -21 -23
            -22 -23 -290 -23 l-268 0 0 450 0 450 267 0 c260 0 267 -1 290 -22z"/>
            <path class="gjs-block-svg-path" 
            d="M253 983 c-18 -7 -16 -40 3 -47 9 -3 37 -6 64 -6 27 0 55 3 64 6 21
            8 21 40 0 48 -18 7 -113 7 -131 -1z"/>
            <path class="gjs-block-svg-path"  
            d="M253 823 c-18 -7 -16 -40 3 -47 32 -12 121 -6 134 9 23 27 -5 45 -69
            44 -31 0 -62 -3 -68 -6z"/>
            <path class="gjs-block-svg-path" 
            d="M253 663 c-18 -7 -16 -40 3 -47 32 -12 121 -6 134 9 23 27 -5 45 -69
            44 -31 0 -62 -3 -68 -6z"/>
            </g>
            </svg>
            <div class='gjs-fontFamily gjs-block-label'>Sidebar1</div>`,
        attributes: { },
        content: `     
            <div class="container-fluid">
                <div class="row flex-nowrap">
                    <div class="col-auto col-md-3 col-xl-2 bg-dark px-0">
                        <div class="d-flex flex-column align-items-center align-items-sm-start  pt-2 text-white min-vh-100">
                            <span href="/" class="pointer d-flex align-items-center pb-3 mb-md-0 me-md-auto text-white text-decoration-none max-width px-4">
                                <span class="fs-5 d-none d-sm-inline">Menu</span>
                            </span>
                            <ul class="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start max-width" id="menu">
                                <li class="nav-item max-width">
                                    <span href="#" class="pointer nav-link align-middle px-4">
                                        <i class="fs-4 bi-house"></i> <span class="ms-1 d-none d-sm-inline">Home</span>
                                    </span>
                                </li>
                                <li class="max-width">
                                    <span href="#submenu1" data-bs-toggle="collapse" class="pointer nav-link align-middle px-4">
                                        <i class="fs-4 bi-speedometer2"></i> <span class="ms-1 d-none d-sm-inline">Dashboard</span> </span>
                                    <ul class="collapse show nav flex-column ms-1" id="submenu1" data-bs-parent="#menu">
                                        <li class="w-100">
                                            <span href="#" class="pointer nav-link px-5"> <span class="d-none d-sm-inline">Item</span> 1 </span>
                                        </li>
                                        <li>
                                            <span href="#" class="pointer nav-link px-5"> <span class="d-none d-sm-inline">Item</span> 2 </span>
                                        </li>
                                    </ul>
                                </li>
                                <li class="max-width">
                                    <span href="#" class="pointer nav-link align-middle px-4">
                                        <i class="fs-4 bi-table"></i> <span class="ms-1 d-none d-sm-inline">Orders</span></span>
                                </li>
                                <li class="max-width">
                                    <span href="#submenu2" data-bs-toggle="collapse" class="pointer nav-link align-middle px-4">
                                        <i class="fs-4 bi-bootstrap"></i> <span class="ms-1 d-none d-sm-inline">Bootstrap</span></span>
                                    <ul class="collapse nav flex-column ms-1" id="submenu2" data-bs-parent="#menu">
                                        <li class="w-100">
                                            <span href="#" class="pointer nav-link px-5"> <span class="d-none d-sm-inline">Item</span> 1</span>
                                        </li>
                                        <li>
                                            <span href="#" class="pointer nav-link px-5"> <span class="d-none d-sm-inline">Item</span> 2</span>
                                        </li>
                                    </ul>
                                </li>
                                <li class="max-width">
                                    <span href="#submenu3" data-bs-toggle="collapse" class="pointer nav-link align-middle px-4">
                                        <i class="fs-4 bi-grid"></i> <span class="ms-1 d-none d-sm-inline">Products</span> </span>
                                        <ul class="collapse nav flex-column ms-1" id="submenu3" data-bs-parent="#menu">
                                        <li class="w-100">
                                            <span href="#" class="pointer nav-link px-5"> <span class="d-none d-sm-inline">Product</span> 1</span>
                                        </li>
                                        <li>
                                            <span href="#" class="pointer nav-link px-5"> <span class="d-none d-sm-inline">Product</span> 2</span>
                                        </li>
                                        <li>
                                            <span href="#" class="pointer nav-link px-5"> <span class="d-none d-sm-inline">Product</span> 3</span>
                                        </li>
                                        <li>
                                            <span href="#" class="pointer nav-link px-5"> <span class="d-none d-sm-inline">Product</span> 4</span>
                                        </li>
                                    </ul>
                                </li>
                                <li class="max-width">
                                    <span href="#" class="pointer nav-link align-middle px-4">
                                        <i class="fs-4 bi-people"></i> <span class="ms-1 d-none d-sm-inline">Customers</span> </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col py-3" style="overflow-x: auto">
                        <h3>Left Sidebar with Submenus</h3>
                        <p class="lead">
                            An example 2-level sidebar with collasible menu items. The menu functions like an "accordion" where only a single 
                            menu is be open at a time. While the sidebar itself is not toggle-able, it does responsively shrink in width on smaller screens.</p>
                        <ul class="list-unstyled">
                            <li><h5>Responsive</h5> shrinks in width, hides text labels and collapses to icons only on mobile</li>
                        </ul>
                    </div>
                </div>
            </div>      
        `
    });

} 

export default sidebar1;
